import React, { useEffect } from 'react';
import SideBar from '../SideBar';
import { useDispatch, useSelector } from 'react-redux';
import { getPageContent } from '../../../store/actions/general.actions';
import { createMarkup } from '../../../utils/helper';
import NewLoading from '../../../Components/Common/NewLoading';

const Faq = (props) => {

    const dispatch = useDispatch();
    const { pageContent, pageLoading } = useSelector((state) => state.general);

    useEffect(() => {
        dispatch(getPageContent('faq'));
    }, []);

    return (pageLoading ?
        <NewLoading customClass="min-height-loader" />
        : <div className='d-flex w-100 static-wrap'>
            <SideBar history={props.history} />
            <div className='static-right w-100'>
                <h1>{pageContent?.title}</h1>
                <div className='theme-dark-bg'>
                    <p dangerouslySetInnerHTML={createMarkup(pageContent?.content || '')} className="about-para" />
                </div>
            </div>
        </div>
    );
};

export default Faq;